module.exports = __webpack_public_path__ + "static/Jolabjor_bakgrunnur_focus-e8d2bce3f7dfb0d478272f0c02003ed5.mp4";